if (!customElements.get('tpt-product-live-variant')) {
	customElements.define(
		'tpt-product-live-variant',
		class VariantSelectsCard extends HTMLElement {
			constructor() {
				super();

				this.productContainer = this.closest('[data-product-live-container]');
				this.productVariants = this.productContainer.querySelectorAll('fieldset.product-form__input');

				this.addEventListener('change', this.onVariantChange);
			}

			onVariantChange(event) {
				this.updateOptions();
				this.updateMasterId();
				this.removeErrorMessage();
				this.updateVariantStatuses();

				if (this.currentVariant) {
					this.renderProductInfo();
				}
			}

			updateOptions() {
				this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
					if (element.tagName === 'SELECT') {
						return element.value;
					}
					if (element.tagName === 'FIELDSET') {
						return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
					}
				});
			}

			updateMasterId() {
				this.currentVariant = this.getVariantData().find((variant) => {
					return !variant.options
						.map((option, index) => {
							return this.options[index] === option;
						})
						.includes(false);
				});
			}

			updateVariantStatuses() {
				const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(':checked').value === variant.option1);
				const inputWrappers = [...this.querySelectorAll('.product-form__input')];
				inputWrappers.forEach((option, index) => {
					if (index === 0) return;
					const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
					const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
					const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
					this.setInputAvailability(optionInputs, availableOptionInputsValue);
				});
			}

			setInputAvailability(elementList, availableValuesList) {
				elementList.forEach((element) => {
					const value = element.getAttribute('value');
					const availableElement = availableValuesList.includes(value);

					if (element.tagName === 'INPUT') {
						element.classList.toggle('disabled', !availableElement);
					} else if (element.tagName === 'OPTION') {
						element.innerText = availableElement ? value : window.variantStrings.unavailable_with_option.replace('[value]', value);
					}
				});
			}

			removeErrorMessage() {
				const section = this.closest('section');
				if (!section) return;

				const productForm = section.querySelector('product-form');
				if (productForm) productForm.handleErrorMessage();
			}

			renderProductInfo() {
				const requestedVariantId = this.currentVariant.id;

				const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

				fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
					.then((response) => response.text())
					.then((responseText) => {
						const html = new DOMParser().parseFromString(responseText, 'text/html');
						const boxImageProduct = this.productContainer.querySelector('.tpt-product-live__box--image');
						const boxPriceProduct = this.productContainer.querySelector('.tpt-product-live__price--container');
						const boxPriceProductSticky = this.productContainer.querySelector('.tpt-product-live__sticky--price');
						const productIdElement = this.productContainer.querySelector('product-form input[name="id"]');
						const buttonCartElement = this.productContainer.querySelector('product-form .product-form__submit');
						const buttonCartElementSticky = this.productContainer.querySelector('tpt-trigger-add-cart');

						const imageElement = html.getElementById('tpt-variant-image');
						const priceElement = html.getElementById('tpt-variant-price');
						const buttonElement = html.getElementById('tpt-variant-button');
						const buttonElementText = buttonElement.getAttribute('data-button-text');

						/**
						 * Update image
						 */
						if (imageElement) {
							boxImageProduct.innerHTML = imageElement.innerHTML;
						}

						/**
						 * Update price
						 */
						if (priceElement) {
							if (priceElement.querySelector('.price-min-max')) {
								priceElement.querySelector('.price-min-max').remove();
							}

							boxPriceProduct.innerHTML = priceElement.innerHTML;
						}

						if (boxPriceProductSticky) {
							if (priceElement.querySelector('.price-min-max')) {
								priceElement.querySelector('.price-min-max').remove();
							}

							boxPriceProductSticky.innerHTML = priceElement.innerHTML;
						}

						/**
						 * Update variant ID
						 */
						if (productIdElement) {
							productIdElement.value = requestedVariantId;
						}

						/**
						 * Upate button add to cart
						 */
						if (buttonElement.getAttribute('data-disabled') == 'true') {
							buttonCartElement.setAttribute('disabled', true);
							buttonCartElementSticky.setAttribute('disabled', true);
						} else {
							buttonCartElement.removeAttribute('disabled');
							buttonCartElementSticky.removeAttribute('disabled');
						}

						buttonCartElement.querySelector('.btn-text').innerHTML = buttonElementText;
						buttonCartElementSticky.querySelector('.btn-text').innerHTML = buttonElementText;

						updateProductLiveVariantStiky(this.productVariants);
					});
			}

			getVariantData() {
				this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
				return this.variantData;
			}
		}
	);
}
